// userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
    name: "user",
    initialState: {
        userId: null,
        weightUnit: "metric"
    },
    reducers: {
        setUserIdStore: (state, action) => {
            state.userId = action.payload;
        },
        setWeightUnitStore: (state, action) => {
            state.weightUnit = action.payload;
        },
    },
});


export const { setUserIdStore, setWeightUnitStore } = userSlice.actions;
export const currentUserId = (state) => state.user.userId;
export const userWeightUnit = (state) => state.user.weightUnit;
export default userSlice.reducer;
